import { render, staticRenderFns } from "./UhCard.vue?vue&type=template&id=71fcf057"
import script from "./UhCard.vue?vue&type=script&lang=js"
export * from "./UhCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports